<script>
import Layout from '@layouts/main.vue'
import { useHead } from '@vueuse/head'

export default {
  setup() {
    useHead(() => ({
      title: 'エラー',
      meta: [{ name: 'description', content: 'システムエラー' }],
    }))
  },
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <Layout>
    <h1 :class="$style.title"> システムエラー </h1>
  </Layout>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
